import gql from 'graphql-tag'

const deleteCliente = gql`
  mutation deleteCliente($id: Int!) {
    deleteCliente(id: $id) {
      id
      agenteId
      nome
      comune
      email
      email2
      telefono
      telefono2
      dataNascita
      lingua
      tipoPnl
      famiglia
      percheCompra
      quandoInteressato
      quantoInteressato
      voto
      dataCreazione
      daRicontattare
      dataUltimoContatto
      dataUltimaRichiesta
      zone {
        nome
      }
      interessi {
        nome
      }
    }
  }
`

export default deleteCliente


// WEBPACK FOOTER //
// ./src/graphql/mutations/deleteCliente.js